<template>
  <v-container fluid pt-0>
    <v-row align="center" class="pb-2">
      <h1 class="headline">
        {{ this.$store.getters.isCPS ? "Itinerary Destinations" : "Brands" }}
      </h1>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" fab dark color="primary" @click="onCreateNew">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span
          >Create New
          {{
            this.$store.getters.isCPS ? "Itinerary Destination" : "Brand"
          }}</span
        >
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          :search="search"
          item-key="id"
          class="elevation-1"
          v-bind="pagingOptions"
          mobile-break-point="1264"
        >
          <template v-slot:item.notInUse="{ item }">
            <v-simple-checkbox
              v-model="item.notInUse"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              hide-view
              @deleteItem="onDeleteItem"
              @editItem="onEditItem"
            ></default-list-actions>
          </template>
        </v-data-table> </v-col
    ></v-row>
    <edit-brand-dialog
      v-model="editedBrand"
      :show="showBrandEditor"
      @close="showBrandEditor = false"
      @input="onSave"
    ></edit-brand-dialog>
  </v-container>
</template>

<script>
import { ListMixin } from "../../../../mixins/ListMixin";
import { removeGQLTypename } from "../../../../helpers";
import DefaultListActions from "../../shared/DefaultListActions";
import gql from "graphql-tag";
import EditBrandDialog from "./EditBrandDialog";
const BRANDS_QUERY = gql`
  query brandsList($after: String, $filter: BrandFilterType) {
    brands(first: 10000, after: $after, filter: $filter) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          notInUse
          paymentTerms {
            edges {
              node {
                isPercent
                days
                amount
                altAmount
                termType
              }
            }
          }
        }
      }
    }
  }
`;
const DELETE_MUTATION = gql`
  mutation deleteBrand($id: ID!) {
    deleteBrand(id: $id) {
      id
    }
  }
`;
const CREATE_MUTATION = gql`
  mutation createBrand($input: BrandInput) {
    createBrand(brandInput: $input) {
      id
      name
      notInUse
      paymentTerms {
        edges {
          node {
            isPercent
            days
            amount
            altAmount
            termType
          }
        }
      }
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updateBrand($id: ID!, $input: BrandInput) {
    updateBrand(id: $id, brandInput: $input) {
      id
      name
      notInUse
      paymentTerms {
        edges {
          node {
            isPercent
            days
            amount
            altAmount
            termType
          }
        }
      }
    }
  }
`;
export default {
  name: "brand-list",

  mixins: [ListMixin],

  components: { DefaultListActions, EditBrandDialog },

  data() {
    return {
      debug: false,
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Not In Use",
          value: "notInUse",
          name: "notInUse",
        },
        {
          text: "Actions",
          value: "actions",
          name: "actions",
        },
      ],
      editedBrand: {},
      showBrandEditor: false,
    };
  },

  computed: {
    items() {
      return this.brands && this.brands.edges
        ? this.brands.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onCreateNew() {
      this.editedBrand = {
        name: `New ${
          this.$store.getters.isCPS ? "Itinerary Destination" : "Brand"
        }`,
        paymentTerms: [],
      };
      this.showBrandEditor = true;
    },
    onEditItem(item) {
      this.editedBrand = {
        ...item,
        paymentTerms: item.paymentTerms.edges.map(removeGQLTypename),
      };
      this.showBrandEditor = true;
    },

    async onDeleteItem(payload) {
      try {
        await this.$apollo.mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: payload.id,
          },
          refetchQueries: [
            {
              query: BRANDS_QUERY,
            },
          ],
        });
        this.$store.dispatch("showAppSnackbar", {
          msg: "Brand deleted",
        });
      } catch (error) {
        const errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg,
          color: "error",
        });
      }
    },
    async onSave(payload) {
      const { id, ...input } = payload;
      const mutation = payload.id ? UPDATE_MUTATION : CREATE_MUTATION;

      try {
        const mutationRes = await this.$apollo.mutate({
          mutation: mutation,
          variables: { input: { ...input }, id },
          refetchQueries: [
            {
              query: BRANDS_QUERY,
            },
          ],
        });
        this.showBrandEditor = false;
        this.$store.dispatch("showAppSnackbar", {
          msg: "Brand saved.",
        });
      } catch (error) {
        const errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg,
          color: "error",
        });
      }
    },
  },

  apollo: {
    brands: {
      query: BRANDS_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/plugins/brands/BrandList.vue